import { render, staticRenderFns } from "./ShiftToolbar.vue?vue&type=template&id=6b518c67"
import script from "./ShiftToolbar.vue?vue&type=script&lang=js"
export * from "./ShiftToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports